import React from 'react';
import './UnlimitedMobileLayoutToggleButton.css';

export default function UnlimitedMobileLayoutToggleButton({ isSideBySide, onToggle }) {
  return (
    <button
      type="button"
      className={`unlimited-layout-toggle header-pill-button ${isSideBySide ? 'is-on' : ''}`}
      onClick={onToggle}
      aria-pressed={isSideBySide}
      aria-label={isSideBySide ? 'Stack image and grid' : 'Show image and grid side by side'}
      title={isSideBySide ? 'Stack' : 'Side by side'}
    >
      {isSideBySide ? 'Stack View' : 'Split View'}
    </button>
  );
}

